export const translationsPanel = {
    name: "description",
    title: "Beskrivelse",
    category: "Panels",
    json: {
      type: "paneldynamic",
      name: "descriptions",
      title: "Beskrivelse",
      renderMode: "tab",
      panelCount: 3,
      templateTabTitle: "{panel.language}",
      showNumber: false,
      allowAddPanel: false,
      allowRemovePanel: false,
      minPanelCount: 3,
      maxPanelCount: 3,
      templateElements: [
        {
          type: "comment",
          name: "translation_text",
          title: "Oversat Tekst"
        }
      ],
      defaultValue: [
        { language_code: "da", language: "Dansk", translation_text: "" },
        { language_code: "en", language: "Engelsk", translation_text: "" },
        { language_code: "de", language: "Tysk", translation_text: "" }
      ],
      // Force the component to always use the default structure
      valueName: "descriptions",
      isRequired: false
    }
  };
  